import React from 'react';
import config from '../config/config';

const ICON_URLS = {
  close: `${config.icons.baseUrl}${config.icons.close}`,
};

/**
 * キーボードショートカット情報コンポーネント
 */
const KeyboardInfo = ({
  isKeyboardInfoOpen,
  onCloseKeyboardInfo
}) => {

  if (!isKeyboardInfoOpen) {
    return null;
  }

  return (
    <div
      className="shortcut-content-overlay"
      onPointerDown={(e) => {
        if (e.target === e.currentTarget) {
          onCloseKeyboardInfo();
        }
      }}
    >

      <div className="shortcut-content">
        <button
          id="close-shortcut-popup"
          className="close-btn"
          onClick={onCloseKeyboardInfo}>
          <i
            className="svg-icon-black"
            style={{
              backgroundImage: `url('${ICON_URLS.close}')`
            }}>
          </i>
        </button>
        <h2>キーボードショートカット</h2>
        <ul>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">↑</span>
                <span className="key">↓</span>
                <span className="key">←</span>
                <span className="key">→</span>
              </strong></span>
            <span className="shortcut-description">地図を移動</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Shift</span>+<span className="key">-</span>
              </strong>
            </span>
            <span className="shortcut-description">ズームイン</span>
          </li>
          <li>
            <span className="key-combo"><strong><span className="key">-</span></strong></span>
            <span className="shortcut-description">ズームアウト</span>
          </li>
          <li>
            <span className="key-combo"><strong>
              <span className="key">Shift</span>+<span className="key">←</span>
            </strong>
            </span>
            <span className="shortcut-description">時計回りに回転</span>
          </li>
          <li>
            <span className="key-combo"><strong>
              <span className="key">Shift</span>+<span className="key">→</span>
            </strong>
            </span>
            <span className="shortcut-description">反時計回りに回転</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Shift</span>+<span className="key">↑</span>
              </strong>
            </span>
            <span className="shortcut-description">上に傾斜</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Shift</span>+<span className="key">↓</span>
              </strong>
            </span>
            <span className="shortcut-description">下に傾斜</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">,</span>
              </strong>
            </span>
            <span className="shortcut-description">メニューの表示/非表示</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">F</span>
              </strong>
            </span>
            <span className="shortcut-description">フルスクリーンで見る</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">L</span>
              </strong>
            </span>
            <span className="shortcut-description">現在地を表示</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">N</span>
              </strong>
            </span>
            <span className="shortcut-description">地図を北向きにリセット</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">R</span>
              </strong>
            </span>
            <span className="shortcut-description">地図を初期状態にリセット</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">1</span>
              </strong>
            </span>
            <span className="shortcut-description">デフォルトデザインに戻す</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">2</span>
              </strong>
            </span>
            <span className="shortcut-description">境界線マップにする</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">3</span>
              </strong>
            </span>
            <span className="shortcut-description">通り名マップにする</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">4</span>
              </strong>
            </span>
            <span className="shortcut-description">地形図にする</span>
          </li>
          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">Shift</span>+<span className="key">5</span>
              </strong>
            </span>
            <span className="shortcut-description">ひらがなマップにする</span>
          </li>

          <li>
            <span className="key-combo">
              <strong>
                <span className="key">esc</span>
              </strong>
            </span>
            <span className="shortcut-description">モード終了</span>
          </li>

          <li>
            <span className="key-combo">
              <strong>
                <span className="key">Ctrl</span>+<span className="key">/</span>
              </strong>
            </span>
            <span className="shortcut-description">ショートカット一覧</span>
          </li>

        </ul>
      </div>
    </div>
  )
};

export default KeyboardInfo;